export const ChecklistBell = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.28581 7.91481L7.22331 8.53981L8.783 6.46022M11.5066 7.50001H13.59M6.28581 12.9157L7.22331 13.5407L8.783 11.4612M16.875 8.95833V4.79167C16.875 3.87119 16.1288 3.125 15.2083 3.125H4.79167C3.87119 3.125 3.125 3.87119 3.125 4.79167V15.2083C3.125 16.1288 3.87119 16.875 4.79167 16.875H9.79167M14.076 17.1484C14.2498 17.4814 14.5984 17.7087 15 17.7087C15.4016 17.7087 15.7502 17.4814 15.924 17.1484M17.7083 16.875V14.1667C17.7083 12.6709 16.4958 11.4583 15 11.4583C13.5042 11.4583 12.2917 12.6709 12.2917 14.1667V16.875H17.7083Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChecklistBell
